<template>
  <transition name="forup">
    <div class="bg-white suit-box" v-if="boxshow">
      <div class="warry" id="suitmode">
        <!--头部-->
        <div class="suitmodehead" style="border-top: 1px solid rgba(206, 182, 23, 0.4);">
          <bg-yun>
            <div class="suit-name text-center">
              {{suit.name}}
              <img height="17" :src="icon" v-for="icon in suit.iconPath">
            </div>
            <div class="suit-sub-title suit-price flex-layout padding-10">
              <div class="color-yellow font-1 text-center width-auto">{{suit.newPrice}}元/套</div>
              <div class="color-blue font-1" style="width: auto; display: flex;">
                <img v-if="suit.newMemberPrice<suit.newPrice" src="../../assets/image/vipIco.svg"
                     alt="" width="18" style="align-self: center; margin-right: 6px">
                <span v-if="suit.newMemberPrice<suit.newPrice">{{suit.newMemberPrice}}元/套</span>
              </div>
              <div class="text-right width-auto">
              <span class="suit-num" @click.stop="clickSub()">
                <img src="../../assets/image/subIcon.svg" width="30" style="vertical-align: middle;pointer-events: none;">
              </span>
                <span class="suit-num">{{suit.num}} <span v-if="suit.minOrderNum>1&&suit.num === suit.minOrderNum" style="font-size: 10px;color: orangered">起点</span></span>
                <span class="suit-num" @click.stop="clickAdd()">
                <img src="../../assets/image/addIcon.svg" width="30" style="vertical-align: middle;pointer-events: none;">
              </span>
              </div>
            </div>
          </bg-yun>
        </div>

        <div class="suitmodecontent">
          <scroller>
            <div class="bg-yellow" v-for="group in suit.group">
              <div class="magin-l-10 padding-5 font-0-8 flex-layout">
                <div class="magin-l-6 flex-1">{{group.groupName}}&nbsp;&nbsp;<span class="color-yellow">{{parseData(group.count)}}</span></div>
                <div v-if="group.needCount>0" class="color-blue padding-r-15 flex-1 text-right">{{parseData2(group.needCount)}}</div>
              </div>
              <bg-yun>
                <div class="padding-10 menuItem text-nowrap font-0-8"  v-for="(itemsuit,index) in group.suiteItem">
                  <div @click.stop="clickItemSuit(group,itemsuit,index)" style="position: relative">
                    <img v-if="!itemsuit.isSelect" src="../../assets/image/okIco1.png" width="20" style="vertical-align: middle;pointer-events: none;">
                    <img v-if="itemsuit.isSelect" src="../../assets/image/okIco.png" width="20" style="vertical-align: middle;pointer-events: none;">
                    <span class="magin-l-6 text-nowrap">{{itemsuit.num*1}}× &nbsp;&nbsp;&nbsp;[{{itemsuit.standard}}]{{itemsuit.name}}</span>
                    <div style="position: absolute;bottom:-15px;left:39%;" v-if="itemsuit.isSaleout">
                      <img src="./soldout.svg" width="50">
                    </div>
                  </div>
                  <div class="suit-remark">
                    <div  v-for="remak in itemsuit.remark"  class="remark-item" @click.stop="clickRemark(itemsuit.isSelect,remak)">
                      <img v-if="!remak.isSelect" src="../../assets/image/okIco1.png" width="20" style="vertical-align: middle;pointer-events: none;">
                      <img v-if="remak.isSelect" src="../../assets/image/okIco.png" width="20" style="vertical-align: middle;pointer-events: none;">
                      {{remak.name}}
                    </div>
                  </div>
                </div>
              </bg-yun>
            </div>

            <!--图片加描述-->
            <div class="magin-t-6" style="font-size: 0" v-if="suit.picMode>0 || suit.desc">
              <bg-yun>
                <img v-if="suit.picMode>0" :src="suit.picPath"  onerror="this.src='static/image/error.jpg'" width="100%">
                <div class="padding-5 font-0-8" v-if="suit.desc">{{suit.desc}}</div>
              </bg-yun>
            </div>
          </scroller>
        </div>
      </div>
      <div class="suit-bottom flex-layout text-center font-1-2" v-if="boxshow">
        <div class="btm-btn flex-1 color-gray-yellow"  @click.stop="btnCancel()">
        <img src="../../assets/image/cancel.svg" width="20" style="vertical-align: middle;padding-bottom: 2px">
          返回
        </div>
        <div class="btm-btn flex-1 bg-gray-yellow color-white"  @click.stop="btnOK()">
          <img src="../../assets/image/ok.svg" width="25" style="vertical-align: middle;padding-bottom: 2px">
          确定
        </div>
      </div>
    </div>
  </transition>

</template>

<script>

 import ServiceUtil from '../../service/ServiceUtils'
  import ServiceDialog from '../../service/ServiceDialog';
  import math from 'mathjs';
  import bgyun from "../bg-yun/bgyun";

  export default {
    name: 'suit',
    data () {
      return{
        boxshow:false,
        suit:{},
        _callback:{}
      }
    },
    components:{
      'bg-yun':bgyun
    },
    filters: {
      toFixed: function (value) {
        value = value*1 || 0;
        return value.toFixed(2)
      }
    },
    methods:{
      parseData(data){
        return `[选${data}种]`
      },
      parseData2(data){
        return `[缺${data}种]`
      },
      togglebox:function(suit,callback){
        // this.orderpic = ServiceUtil.config.dicDomain+'/weixin/document/';
        this.boxshow = !this.boxshow;
        suit.num = suit.minOrderNum || 1;
        this.suit = suit;
        this.$nextTick(function() {
          document.querySelector("#suitmode").scrollTop = 0;
        });
        if(callback){
          this._callback = callback
        }
        this.refresh();
      },

      refresh:function(){
        this.suit.newPrice = this.suit.price;
        this.suit.newMemberPrice = this.suit.memberprice;
        this.suit.group.forEach(function(groupItem){
          var c = 0;
          groupItem.suiteItem.forEach( function(item) {
            item.isSelect = false;
            if (item.selectflag == 1 && !item.isSaleout) {
              item.isSelect = true;

            }
            if(item.selectflag == 1){
              c++;
            }
          });
          groupItem.count = c;
          groupItem.needCount = 0;
        });
      },

      //      点击加号
      clickAdd(){
        this.suit.num = this.suit.num+1;
        console.log(this.suit);
        this.$forceUpdate();
      },
//      点击减号
      clickSub(){
        this.suit.num--;
        this.suit.num =  Math.max(this.suit.num,this.suit.minOrderNum || 1);
        this.$forceUpdate();
      },
//      点击单个菜品
      clickItemSuit(group,item,i){

        if(item.isSaleout)return

        let lastIndex = 0;
        let count = 0;
        item.isSelect =!item.isSelect;
        if(!item.isSelect && item.remark){
          item.remark.forEach((remarkItem)=>{remarkItem.isSelect=false});
        }
        group.suiteItem.forEach((suititem,index)=>{
          if(suititem.isSelect){
            count++;
            if(i!=index){
              lastIndex = index;
            }
          }
        });
        if(count>group.count){
          group.suiteItem[lastIndex].isSelect=false;
          group.suiteItem[lastIndex].remark.forEach((remarkItem)=>{remarkItem.isSelect=false});
        }
        if(count<=group.count){
          group.needCount = group.count - count;
        }
        let _newPrice = 0;
        let _newMemberPrice = 0;
        this.suit.group.forEach(groupItem=>{
          groupItem.suiteItem.forEach(suiteItem=>{
            if(suiteItem.isSelect){
              _newPrice += math.round(suiteItem.price*suiteItem.num,2);
              _newMemberPrice += math.round((suiteItem.memberprice || suiteItem.price)*suiteItem.num,2);
            }
          });
        });
        this.suit.newPrice = _newPrice.toFixed(2);
        this.suit.newMemberPrice = _newMemberPrice.toFixed(2);
        this.$forceUpdate();
      },
      //加做法选择
      clickRemark(itemsuit,remark){
        if(itemsuit){
          remark.isSelect = !remark.isSelect;
          this.$forceUpdate();
        }
      },

      btnCancel: function(){
        this.boxshow = !this.boxshow;
      },
      btnOK:function(){
        let isOk = true;
        let err = "";
        let addReamrk = function(order){
          let _str= '' ;
          if(order.remark){
            order.remark.forEach((item)=>{
              if(item.isSelect){
                _str+=item.name+'、';
              }
            });
          }
          return _str;
        };

        let food = {
          code :this.suit.code,
          name :this.suit.name,
          sndname:this.suit.sndname||"",
          standard:this.suit.standard ||"",
          price :  this.suit.newPrice|| this.suit.price,
          num :this.suit.num,
          memo :"",
          menuItem : []
        } ;

        this.suit.group.forEach(function(group){
          var c = 0 ;
          group.suiteItem.forEach(function(item){
            if(item.isSelect){
              c++;
              var suiteItem = {
                code: item.code,
                name: item.name,
                sndname: item.sndname,
                standard: item.standard,
                price: item.price,
                memberprice: item.memberprice,
                num: item.num,
                memo: addReamrk(item),
                sgid: group.groupNo||'0'
              }
              food.menuItem.push(suiteItem);
            }
          });
          if(c!=group.count){
            isOk = false;
            err = "{0}还差{1}份,请继续选择!".format(group.groupName,group.count-c);
            return;
          }
        });
        if (isOk) {
          console.log("food suit",food);
          ServiceUtil.setSuitData(food);
          if(this._callback){
            this._callback();
          }
          this.boxshow = !this.boxshow;
        }else{
          ServiceDialog.showAlert('温馨提示',err)
        }
      },
    },
    created(){}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .flex-1{flex:1;overflow:hidden;width: 0}
  .color-gray-yellow{color:#CEB66B}
  .bg-gray-yellow{background:#CEB66B}
  .color-white{color:#ffffff}
  .font-1-2{font-size: 1.2em;}
  .flex-layout{ display: flex;  align-items: center;}
  .warry{position: fixed;top: 50px;bottom: 0;left: 0;right: 0;background-color:white;z-index: 999;}
  .suit-bottom{position: fixed;height: 50px;top: 0;left: 0;right: 0;background-color:white;z-index: 999; ;  }
  .mybox-enter-active {  animation: bounce-in .3s;  }
  .mybox-leave-active {  animation: bounce-in .3s reverse;  }
  @keyframes bounce-in {
    0% {transform: scale(0);}
    100% {transform: scale(1);} }
  .suit-name{  height: 40px;  line-height: 40px;  border-bottom: 1px solid rgba(139, 69, 19, 0.16);  }
  .suit-price{  height: 40px;  line-height: 40px;  background: #FDFCF8;  }
  .btm-btn{  height: 100%;  line-height: 50px;  }
  .menuItem{  border-bottom: 1px solid #EEE0CA;  }
  .menuItem:last-child{  border-bottom:none;  }
  .suit-box{position:absolute;top:0;bottom: 0;left: 0;right: 0;overflow: hidden;z-index: 20;}
  .suitmodehead{position:absolute;top:0;bottom: 0;left: 0;right: 0;height: 118px;}
  .suitmodecontent{position:absolute;top:118px;bottom: 0;left: 0;right: 0;}
  .suit-remark{display: flex; flex: 1; flex-direction: row; flex-wrap: wrap; padding: 10px 30px 0 30px;}
  .remark-item{flex: 1; flex-wrap: wrap; padding: 6px 10px 6px 0;}
  .suit-sub-title{display: flex; flex-direction: row; justify-content: space-around}
  .bg-white{background:#ffffff}
  .text-center{text-align: center};
  .flex-layout{ display: flex;  align-items: center;}
  .padding-10{padding: 10px;}
  .color-yellow{color:#FF6D00}
  .font-1{font-size: 1em;}
  .width-auto{width: auto;}
  .color-blue{color:#00ABF8}
  .text-right{text-align: right}
  .suit-num{  display: inline-block;  border-radius: 3px;   text-align: center; min-width: 30px }
  .magin-l-10{
    margin-left: 10px;
  }
  .font-0-8{font-size: 0.8em;}
  .bg-yellow{background: #F7F3E7;}
  .magin-t-6{
    margin-top: 6px;
  }
  .magin-l-6{
    margin-left: 6px;
  }
  .padding-5{padding: 5px;}
  .text-nowrap{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .padding-r-15{
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/suitMode/suitmode.vue